/**
 * TODO:
 * We shouldn't use core colors in components, like (lime, red).
 * but as we don't have the colors mapped on semantic layers yet,
 * we will keep using core colors for now.
 * @see https://etherapists.atlassian.net/browse/HUM-23690
 */

import { cva } from 'class-variance-authority';

export const iconColorVariants = cva('', {
  variants: {
    variant: {
      default: 'var(--color-white)',
      success: 'var(--color-lime-400)',
      destructive: 'var(--color-red-500)',
    },
  },
  defaultVariants: { variant: 'success' },
});

export const textVariants = cva('', {
  variants: {
    variant: { default: 'text-white', success: 'text-lime-400', destructive: 'text-red-500' },
  },
  defaultVariants: { variant: 'success' },
});
